import styled from 'styled-components';

import { fontFamily } from '../../GlobalStyles/Colors';

export const FallowersDiv = styled.div`
    display: flex;
    font-family: ${fontFamily};
    text-align: center;
    width: 90%;
    justify-content: justify;
    margin: auto;
    flex-wrap: wrap;
`